import i18n from 'i18next'
import Swal from 'sweetalert2'
import { toast } from 'react-toastify'

import http from './http'
import { TApi } from './const'
import { renderRequirements } from './helpers'
import { getActivationRequirements } from './activationRequirements'

/*
 * Das Fenster hinter „Zur Genehmigung einreichen".
 *
 * Es steht an zwei Stellen: auf dem Dashboard der Schüler:innen und in der
 * Mitteilung „Bereit zum Einreichen". Beide bauten es bis 21.08.2026 selbst —
 * mit demselben Aufruf, Zeile für Zeile abgeschrieben. Wer die Gestalt des
 * Fensters änderte, änderte sie an einer der beiden Stellen nicht mit.
 *
 * Es lässt sich auf drei Wegen schließen: Kreuz rechts oben, Klick daneben,
 * Esc — dieselbe Regel wie bei den übrigen Fenstern der Anwendung
 * (shared/useDialogDismiss). Vorher ging nur „Abbrechen": Wer das Fenster nur
 * aufgemacht hatte, um nachzusehen, was noch fehlt, musste erst nach dem Knopf
 * suchen, der nach Verwerfen klingt.
 *
 * @param options            Options aus dem Store (Schalter der Voraussetzungen)
 * @param activationsStatus  Erfüllt-Stand vom Server
 * @param onSubmitted        Was nach dem Einreichen zu tun ist — die beiden
 *                           Stellen kommen an den Store unterschiedlich heran.
 * @param onSubmitFailed     Was zu tun ist, wenn der Server ablehnt. Er prüft
 *                           die Voraussetzungen seit 21.08.2026 selbst; seine
 *                           Meldung zeigt der Fehlerweg in shared/http, die
 *                           aufrufende Ansicht lädt ihren Stand nach.
 */
export const openApprovalRequirements = ({ options, activationsStatus, onSubmitted, onSubmitFailed }) => {
	const requirements = getActivationRequirements({ options, activationsStatus })

	// `every` über eine leere Liste ist wahr — und das ist richtig so: Hat die
	// Administration alle Voraussetzungen abgeschaltet, gibt es nichts zu
	// erfüllen, und Einreichen muss trotzdem möglich bleiben.
	const allRequirementsMet = requirements.every(requirement => requirement.status === true)

	return Swal.fire({
		icon: '',
		title: '',
		html: renderRequirements(requirements, allRequirementsMet),
		customClass: {
			popup: 'requirements-popup',
			confirmButton: `requirements-btn ${
				allRequirementsMet ? 'requirements-confirm-btn' : 'requirements-confirm-btn-disabled'
			}`,
			cancelButton: 'requirements-btn requirements-cancel-btn',
			actions: 'requirements-actions'
		},
		showCloseButton: true,
		closeButtonAriaLabel: i18n.t('Close'),
		showCancelButton: true,
		confirmButtonText: i18n.t('Submit'),
		cancelButtonText: i18n.t('Cancel'),
		reverseButtons: true,
		allowOutsideClick: true,
		didOpen: () => {
			if (!allRequirementsMet) {
				const btn = Swal.getConfirmButton()

				if (btn) {
					btn.disabled = true
				}
			}
		},
		preConfirm: async () => {
			if (!allRequirementsMet) {
				return false
			}

			Swal.showLoading()

			try {
				await http.put(TApi.STUDENT_PUT_SET_REVIEW)
				onSubmitted?.({ isNeedReview: true })
				toast.success(i18n.t('Company submitted for verification and activation.'))
			} catch (error) {
				await onSubmitFailed?.()
			}
		}
	})
}
